import { useUserInfo } from '@/store/index'
export const http = (options) => {
  // 1. 返回 Promise 对象
  return new Promise((resolve, reject) => {
    uni.request({
      ...options,
      dataType: 'json',
      // #ifndef MP-WEIXIN
      responseType: 'json',
      // #endif
      // 响应成功
      success(res) {
        // 状态码 2xx，参考 axios 的设计
        if (res.data.code >= 200 && res.data.code < 300) {
          // 2.1 提取核心数据 res.data
          resolve(res.data)
        } else if (res.data.code === 401) {
          // 401错误  -> 清理用户信息，跳转到登录页
          useUserInfo().logout()
          uni.reLaunch({ url: '/pages/login/navigation' })
          reject(res)
        } else {
          // 其他错误 -> 根据后端错误信息轻提示
          /* !options.hideErrorToast &&
            uni.showToast({
              icon: 'none',
              title: (res.data).message || '请求错误',
            }) */
          reject(res)
        }
      },
      // 响应失败
      fail(err) {
        uni.showToast({
          icon: 'none',
          title: '网络错误，换个网络试试',
        })
        reject(err)
      },
    })
  })
}

export const httpUploadFile = (filePath, options) => {
  const VITE_UPLOAD_BASEURL = import.meta.env.VITE_UPLOAD_BASEURL
  // 1. 返回 Promise 对象
  return new Promise((resolve, reject) => {
    uni.uploadFile({
      ...options,
      url: VITE_UPLOAD_BASEURL,
      filePath: filePath,
      // 响应成功
      success(res) {
        // 状态码 2xx，参考 axios 的设计
        if (res.data.code >= 200 && res.data.code < 300) {
          // 2.1 提取核心数据 res.data
          resolve(res.data)
        } else if (res.data.code === 401) {
          // 401错误  -> 清理用户信息，跳转到登录页
          useUserInfo().logout()
          uni.reLaunch({ url: '/pages/login/navigation' })
          reject(res)
        } else {
          reject(res)
        }
      },
      // 响应失败
      fail(err) {
        uni.showToast({
          icon: 'none',
          title: '网络错误，换个网络试试',
        })
        reject(err)
      },
    })
  })
}

/**
 * GET 请求
 * @param url 后台地址
 * @param query 请求query参数
 * @returns
 */
export const httpGet = (url, query) => {
  return http({
    url,
    query,
    method: 'GET',
  })
}

/**
 * POST 请求
 * @param url 后台地址
 * @param data 请求body参数
 * @param query 请求query参数，post请求也支持query，很多微信接口都需要
 * @returns
 */
export const httpPost = (
  url,
  data,
  query,
) => {
  return http({
    url,
    query,
    data,
    method: 'POST',
  })
}

/**
 * DELETE 请求
 * @param url 后台地址
 * @param data 请求body参数
 * @param query 请求query参数，post请求也支持query，很多微信接口都需要
 * @returns
 */
export const httpDelete = (
  url,
  query,
  data
) => {
  return http({
    url,
    query,
    data,
    method: 'DELETE',
  })
}

http.get = httpGet
http.post = httpPost
http.delete = httpDelete
http.uploadFile = httpUploadFile
